import { Button, Typography, Flex } from "@nestoca/ui";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { BsFillArrowLeftCircleFill } from "react-icons/bs";

import { ApplicationSelectorOption } from "../application-selector/application-selector-option";

import styles from "./change-application-modal-body.module.scss";

import type { SelectableApplication } from "../application-selector/types";

type ChangeApplicationModalBodyPropTypes = {
  returnToSettings: () => void;
  applicationId: number;
  closeModal?: () => void;
  selectableApplications: SelectableApplication[];
};

export const ChangeApplicationModalBody = ({
  returnToSettings,
  applicationId,
  closeModal,
  selectableApplications,
}: ChangeApplicationModalBodyPropTypes) => {
  const { t } = useTranslation("applications");

  return (
    <>
      <Flex gap={1} direction="column" align="start">
        <Button
          size="large"
          variant="ghost"
          onClick={returnToSettings}
          className={styles["change-application__back-button"]}
          data-dd-action-name="back"
        >
          <BsFillArrowLeftCircleFill size={24} />
          <Typography size={0} weight={7}>
            {t("back", { ns: "form" })}
          </Typography>
        </Button>
        <Typography
          size={0}
          weight={7}
          className={styles["change-application__title"]}
        >
          {t("change")}
        </Typography>
      </Flex>
      <Flex direction="column" gap={3}>
        {selectableApplications?.map(({ link, id, address, stage }) => {
          return (
            <Link
              onClick={closeModal}
              href={link || "#"}
              data-dd-action-name="application selector"
              key={id}
            >
              <ApplicationSelectorOption
                id={id}
                address={address}
                stage={stage}
                applicationId={applicationId}
              />
            </Link>
          );
        })}
      </Flex>
    </>
  );
};
